import React, {Component} from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";

class MasterLogistikMotorSubSegmenModifying extends Component {
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Sub Segmen"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <form onSubmit={this.handleSubmit}>
                            <ModifyingDDL
                                id="select_options_segmen_"
                                name="idSegment"
                                text="Segmen"
                                mandatory
                                errorMessage={this.props.errors.idSegment}
                                options={this.props.dataSegmenDDL}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? {
                                            label: this.props.controls.idSegment.value.label,
                                            value: this.props.controls.idSegment.value.value,
                                        }
                                        : null
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />
                            <SimpleInput
                                id="input_text_subsegmen"
                                name="subSegmentName"
                                label="Sub Segmen"
                                mandatory
                                errorMessage={this.props.errors.subSegmentName}
                                value={this.props.controls.subSegmentName.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton type="submit">Simpan</SimpleButton>
                            </div>
                        </form>
                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(MasterLogistikMotorSubSegmenModifying);

class ModifyingDDL extends Component {
    render() {
        return (
            <FlexView column hAlignContent="center" style={{flex: 1}}>
                <SimpleDDL
                    containerclassname="margin-botton-5px width width-full"
                    box="search"
                    // isSearchable={false}
                    // isClearable
                    options={this.props.options}
                    label={this.props.text}
                    {...this.props}
                />
            </FlexView>
        );
    }
}